module.exports = __webpack_public_path__ + "a067539858d2b49b1d67fac4696ae834.png";